import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";

interface Props {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

//@Codescene(disable-all)
export default function TermsAndConditions(props: Props) {
  const { openDialog, setOpenDialog } = props;

  const TERMS_CONDITIONS_HTML = (
    <div className="font-skyRegular">
      <h2>PXL - Sky Imagery Portal</h2>
      <h3>Terms and Conditions of Use:</h3>
      <p>
        PLEASE READ THESE TERMS AND CONDITIONS ("AGREEMENT") IN FULL. BY USING
        THIS WEBSITE, YOU AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS AND
        ALL TERMS AND POLICIES INCORPORATED BY REFERENCE. IF YOU DO NOT AGREE,
        IMMEDIATELY DISCONTINUE USING THIS WEBSITE. THIS AGREEMENT CONSTITUTES A
        LEGAL AGREEMENT BETWEEN YOU, THE LEGAL ENTITY WHO HAS REGISTERED A USER
        TO USE THE WEBSITE WITH A VALID USER ID AND PASSWORD (“REGISTERED USER”)
        AND SKY UK LIMITED ("SKY"). YOU FURTHER AGREE THAT ALL OTHER REGISTERED
        USERS ARE THIRD PARTY BENEFICIARIES TO THIS AGREEMENT.
      </p>
      <h3>Ownership of the Website and Content</h3>
      <p>
        “Content” means all of the content displayed on this website (“Website”)
        including, but not limited to, text, graphics, sound, illustrations,
        moving images, photographic images, software, logos, information,
        schedules, video and the arrangement thereof. Apart from any Content you
        have uploaded to the Website, all Content is owned by Sky, its licensors
        or other third-party providers or other Registered Users as appropriate.
        All elements of the Website, including Content, are protected by
        trademark, copyright, trade dress, moral rights and other laws relating
        to intellectual property rights. Unless you are explicitly permitted
        under this Agreement, you may not download, copy, replicate, duplicate,
        adapt, modify, decompile, dissemble, reverse engineer, alter or
        distribute any portion or component of the Website or its Content by any
        means. The Website, it's Content and any related rights shall remain the
        exclusive property of Sky, its licensors, other third-party providers or
        Registered Users as appropriate.{" "}
      </p>
      <h2>Use of Website</h2>
      <p>
        To use the Website, your Registered Users must have a valid user ID and
        password. You are responsible for any activity by such Registered Users
        under user IDs allocated to you as well as maintaining and updating all
        your account information to keep it current, accurate and complete. In
        the event of a breach of your account(s), you must immediately notify
        Sky and Sky will not be liable for any activity that occurs under your
        account(s) or any unauthorised access. Sky reserves the right to cancel
        any or all of your user IDs if Sky becomes aware or suspects any
        unauthorised use of your user ID or by your Registered Users.
      </p>
      <p>
        Subject to this Agreement, your Registered Users may use the Website and
        its included Content for: (a) an editorial piece for the purpose of
        commenting, illustrating, promoting, portraying or otherwise discussing
        the subject matter depicted in the Content; or (b) as otherwise
        expressly permitted on the Website.
      </p>
      <p>
        You and your Registered Users are specifically prohibited from using the
        Website or Content for: (a) any data mining or extraction methods; (b)
        displaying the site using framing or similar navigational technology;
        (c) stockpiling or storing Content for future use; (d) attempting to or
        successfully registering, subscribing or unsubscribing any person or
        party if you are not expressly authorised to do so; (e) using any
        Content in a manner not permitted under this Agreement, including as
        part of any service that resembles this Website; (f) using the Website
        or Content other than for its intended purpose; (g) redistributing any
        Content to a third-party in any form; and/or (h) making the Content
        available in a manner intended to allow a third-party to access it. Any
        unauthorised use may also violate applicable laws, including, but not
        limited to, copyright, trademark, privacy, publicity and applicable
        communications regulations. You agree to ensure that your Registered
        Users use the Website only in the country for which you have registered.
        Any use of the Website or Content for a purpose that is not permitted by
        this Agreement may result in immediate termination of your user ID(s).
        Access to the Website may be suspended by Sky without notice or
        liability at Sky's sole discretion. You must not, and must ensure that
        your Registered Users must not, upload or make available any Content
        that: (a) you do not have a right to make available under any law or
        contract; (b) is unlawful, harmful, threatening, abusive, libellous,
        defamatory, invasive of another's privacy, hateful or racially or
        ethnically objectionable; and/or (c) infringes any intellectual property
        or other rights of any party.
      </p>
      <p>
        By uploading Content to the Website, you: (a) are agreeing to its use by
        Sky, its licensors, other third parties or other Registered Users in
        accordance with "Use of Content" below; (b) warrant that you have
        obtained all intellectual property rights and other third party rights,
        clearances, consents and licenses for the Content and that the use by
        others of that particular Content will not infringe any intellectual
        property or other rights of a third party; (c) are solely responsible
        for your conduct and any Content you upload to the Website; (d) agree to
        indemnify Sky and its associates and all other Registered Users and all
        their subsidiaries, associates, officers, agents, employees, licensors
        and partners from and against any claims, demands, damages, liabilities,
        losses, costs (including legal fees) and expenses arising out of any
        breach by any or all of them of any intellectual property or other
        rights of a third party arising from any Use of Content uploaded by your
        user ID to the Website; (e) must not attempt to modify, hack or adapt
        the Website; and/or (f) must not upload or otherwise make available to
        the Website any material which contains viruses, worms or any computer
        code intended to interrupt, destroy or adversely affect the
        functionality of any computer software or hardware or which would
        interfere with or disrupt the Website.
      </p>
      <h2>Use of Content</h2>
      <p>
        Sky and other Registered Users are permitted to: (a) upload Content to
        the Website following the input of data which is requested through a
        pop-up when entering the Website; (b) view Content uploaded to the
        Website by other Registered Users and Sky, provided that all cached and
        temporarily stored Content is deleted once the Content is viewed; and
        (c) download, as Sky may authorise, the Content for use in accordance
        with any metadata restrictions or terms of this Agreement and you hereby
        grant Sky and other Registered Users (and their licensees) a worldwide,
        royalty-free and non-exclusive licence to use, reproduce, distribute,
        modify, publicly perform and display such Content as necessary to
        undertake any permitted use of the Content, such licence to exist as
        long as the Content is available on the Website.
      </p>
      <p>
        In the event that Sky or other Registered Users are using the Content in
        accordance with this Agreement, and either (a) that Content is removed
        from the Website or (b) you subsequently issue a clear and unambiguous
        limitation or restriction as to certain Content which you have uploaded
        then notwithstanding such removal, limitation or restriction Sky or
        other Registered Users shall have a reasonable period of time from the
        time they first become aware of the removal, limitation or restriction
        to cease or alter their use of the Content.
      </p>
      <p>
        You understand and agree that processing and transmitting Content may
        involve transmissions over various networks and certain changes may be
        made to allow for adaptions to certain devices or networks.
      </p>
      <h2>Information Collected from this Website</h2>
      <p>
        Sky shall own all information concerning the use of the Service, data
        relating to specific users as well as all aggregate information. This
        information will be used in accordance with Sky's privacy policy
        available at
        http://help.sky.com/articles/sky-privacy-and-cookies-notice.
      </p>
      <h2>Trademarks</h2>
      <p>
        "Sky" and the Sky logo are registered trademarks of Sky UK Limited or
        its licensors as appropriate.
      </p>
      <h2>Disclaimer</h2>
      <p>
        This Website may contain links to other websites and to the extent that
        these websites are not controlled by Sky, Sky shall not be held
        responsible for its content and you waive any and all claims against Sky
        regarding the inclusion of links to these websites or your use of these
        websites.
      </p>
      <p>
        You understand and agree that: (a) Sky is under no obligation to make
        use of any Content uploaded to the Website; (b) your use of the Website
        is at your sole risk; (c) the Website is provided on an "as is" and "as
        available" basis; and (d) Sky makes no warranty that the Website will be
        uninterrupted, timely, secure or error-free and Sky and its
        subsidiaries, associates, officers, employers, agents, licensors and
        partners expressly disclaim all warranties of any kind.
      </p>
      <h2>General Conditions</h2>
      <p>
        Sky reserves the right to alter this Agreement at any time. If the
        alteration is a material one (to be determined at Sky's sole discretion
        in good faith using common sense and reasonable judgment), Sky will
        notify you via e-email. Sky reserves the right to alter or remove the
        Website or your access at any time. You acknowledge and agree that Sky
        may access and disclose your account information if required to do so
        under law or if Sky believes in good faith that such access or
        disclosure is reasonably necessary to comply with legal process, enforce
        this Agreement, respond to any third party claims or protect the rights
        of Sky.
      </p>
      <p>
        This Agreement shall be governed by and interpreted in accordance with
        the laws of England and the parties hereby submit to the exclusive
        jurisdiction of the English courts in relation to any legal actions or
        proceedings arising out of or in connection with this Agreement.
      </p>
      <h2>Liability</h2>
      <p>
        SKY, ITS ASSOCIATES, ITS DIRECTORS, MEMBERS, EMPLOYEES OR AGENTS SHALL
        NOT BE HELD LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL OR CONSEQUENTIAL
        DAMAGES, OR DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO LOSS OF
        PROFITS, LOSS OF USE, LOSS OF DATA, WHETHER IN AN ACTION IN CONTRACT,
        TORT OR OTHERWISE, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE
        OF THE WEBSITE OR CONTENT, INCLUDING WITHOUT LIMITATION ANY DAMAGES
        CAUSED BY OR RESULTING FROM RELIANCE BY REGISTERED USERS OR THAT RESULT
        FROM ANY MISTAKES, OMISSIONS, ERRORS, DEFECTS, INTERRUPTIONS, VIRUSES,
        DELETION OF FILES, FAILURE OF PERFORMANCE, WHETHER OR NOT RESULTING FROM
        ACTS OF GOD, THEFT, DESTRUCTION OR UNAUTHORISED ACCESS OR COMMUNICATIONS
        FAILURE. IN NO EVENT SHALL THE AGGREGATE LIABILITY OF SKY, ITS
        ASSOCIATES, ITS DIRETORS, MEMBERS, EMPLOYEES OR AGENTS, WHETHER IN
        CONTRACT, TORT, WARRANTY, PRODUCT LIABILITY OR ANY OTHER THEORY ARISING
        OUT OF THE USE OF THE WEBSITE BE GREATER THAN ANY COMPENSATION YOU PAY,
        IF ANY, TO SKY FOR ACCESS TO THE WEBSITE.
      </p>
    </div>
  );

  const [canCloseDialog, setCanCloseDialog] = useState<boolean>(false);

  //controllo se esiste il cookie termsConditionsAccepted e apro la modale se non esiste
  useEffect(() => {
    const cookieValue = Cookies.get("termsConditionsAccepted");
    const urlParams = new URLSearchParams(window.location.search);
    const isCmsFrame =
      urlParams && urlParams.get("preview") !== null ? true : false;
    console.log("isCmsFrame " + isCmsFrame);
    if (cookieValue !== "true" && !isCmsFrame) {
      setOpenDialog(true);
    } else {
      setCanCloseDialog(true);
      setOpenDialog(false);
    }
  }, [setOpenDialog]);

  const handleClose = () => {
    if (canCloseDialog) {
      setOpenDialog(false);
    }
  };

  const saveCookieTermsConditions = () => {
    Cookies.set("termsConditionsAccepted", "true", { expires: 365 });
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ fontFamily: "SkyTextMedium", fontSize: "2rem" }}
        >
          {"Terms & Conditions"}
        </DialogTitle>
        <DialogContent dividers>{TERMS_CONDITIONS_HTML}</DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disableElevation
            onClick={saveCookieTermsConditions}
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
